'use client'

import { cn } from '@/lib/utils'
import Image from 'next/image'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import benchedImage from '@/public/benched.png'
import benchedDarkImage from '@/public/benched-dark.png'

type BenchedLogoProps = {
  /** Additional Tailwind classes */
  className?: string
  /** Size in pixels (both width & height). Defaults to 48. */
  size?: number
}

/**
 * Renders the Benched logo using the static PNG asset. Rounded to a circle so it matches "full round" usage.
 * Simply pass any Tailwind classes via `className` to control dimensions or colour overlays (e.g. ring-
 * utilities). The built-in `size` prop is a convenience for width/height.
 */
export const BenchedLogo = ({ className, size = 48 }: BenchedLogoProps) => {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  const src = resolvedTheme === 'dark' ? benchedDarkImage : benchedImage

  return (
    <Image
      src={src}
      alt="Benched.ai logo"
      width={size}
      height={size}
      className={cn('rounded-full', className)}
      placeholder="blur"
      priority
    />
  )
}

export default BenchedLogo
